import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "stroke-width": ".3",
      d: "M17.45 6.22C18 5.15 18.36 4.5 19 4.5h.59a1.49 1.49 0 0 0 2.82 0H24v-1h-1.59a1.49 1.49 0 0 0-2.82 0H19c-1.31 0-1.91 1.21-2.45 2.28S15.64 7.5 15 7.5h-.59a1.49 1.49 0 0 0-2.82 0H11c-1.31 0-1.91 1.21-2.45 2.28S7.64 11.5 7 11.5h-.55a2.5 2.5 0 0 0-4.9 0H0v1h1.55a2.5 2.5 0 0 0 4.9 0H7c.64 0 1 .65 1.55 1.72S9.69 16.5 11 16.5h.59a1.49 1.49 0 0 0 2.82 0H15c.64 0 1 .65 1.55 1.72S17.69 20.5 19 20.5h.59a1.49 1.49 0 0 0 2.82 0H24v-1h-1.59a1.49 1.49 0 0 0-2.82 0H19c-.64 0-1-.65-1.55-1.72S16.31 15.5 15 15.5h-.59a1.49 1.49 0 0 0-2.82 0H11c-.64 0-1-.65-1.55-1.72A5.8 5.8 0 0 0 8.27 12c.5-.515.9-1.119 1.18-1.78C10 9.15 10.36 8.5 11 8.5h.59a1.49 1.49 0 0 0 2.82 0H15c.64 0 1 .65 1.55 1.72S17.69 12.5 19 12.5h.59a1.49 1.49 0 0 0 2.82 0H24v-1h-1.59a1.49 1.49 0 0 0-2.82 0H19c-.64 0-1-.65-1.55-1.72A5.8 5.8 0 0 0 16.27 8c.5-.516.9-1.119 1.18-1.78ZM4 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
    }, null, -1),
    _createElementVNode("path", {
      "stroke-width": "1.2",
      d: "M3.692 22.154c2.308 0 3.231-3.692 5.539-3.692a1.846 1.846 0 0 1 0 3.692c-2.308 0-3.231-3.692-5.539-3.692a1.846 1.846 0 0 0 0 3.692Z"
    }, null, -1)
  ]))]))
}
export default { render: render }